import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material'

import closeIcon from '../../../images/closeIcon.svg';
import smallLogo from '../../../images/smallLogo.svg';
import cibleIcon from "../../../images/cibleIcon.svg"
import vignetteModule from '../../../images/vignetteModule.png';

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

/* ⛔ EN-TETE DU PLAN, D'APRES LE NODE 4:2008 — ET IL REMPLACE LE POINT 14.
   Ce point (Nawal, 04/09) demandait de CENTRER le grand logo sur cet ecran, au
   motif que « le Figma le veut centre ». Le Figma actuel, du 17/09, montre
   autre chose : a gauche le petit logo, un trait vertical et le libelle « Plan
   de formation » en 18px ; au centre le nom du module en 14px gris ; a droite
   la croix. La regle n'est donc pas oubliee, elle est remplacee par une lecture
   plus recente de la meme source — exactement comme le point 14 remplacait
   lui-meme la seconde moitie de L20.
   Barre blanche de 75 px, bordee en bas de `#e7e7e7`. */
const TopBar = ({ setViewPlanCours, viewPlanCours, nomModule }) => {
  const navigate = useNavigate();
  const { updateUserContext } = useContext(UserContext)

  // L24 : rafraichir le contexte avant de retourner au dashboard, sinon
  // actFormation/actPlan restent perimes et il faut recharger la page.
  const goDashboard = () => {
    updateUserContext()
    navigate("/dashboard")
  }

  return (
    <Box sx={{
      backgroundColor:"white",
      borderBottom:"1px solid #E7E7E7",
      height:["60px", "75px", "75px", "75px"],
      minHeight:["60px", "75px", "75px", "75px"],
      padding:["0px 16px", "0px 25px", "0px 31px", "0px 31px"],
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      gap:"10px",
      position:"relative",
      flexShrink:0,
    }}>
      <Box onClick={goDashboard} sx={{ display:"flex", alignItems:"center", gap:"10px", cursor:"pointer", minWidth:0 }}>
        <img src={smallLogo} alt="Rising Up" style={{ height:"24.8px", display:"block" }} />
        <Box sx={{ width:"1px", height:"22px", backgroundColor:"rgba(10,10,11,0.2)", flexShrink:0 }} />
        <Box sx={{ fontSize:["15px", "16px", "18px", "18px"], lineHeight:"26px", color:"text.black", whiteSpace:"nowrap" }}>
          Plan de formation
        </Box>
      </Box>

      {/* Le nom du module est centre sur la LARGEUR DE L'ECRAN, pas sur l'espace
          restant : c'est le meme parti que prenait le point 14 pour le logo. */}
      <Box sx={{
        position:"absolute", left:"50%", transform:"translateX(-50%)",
        fontSize:"14px", lineHeight:"26px", color:"rgba(0,0,0,0.6)",
        maxWidth:"40%", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
        display:["none", "block", "block", "block"],
      }}>
        {nomModule}
      </Box>

      <Box
        title="Fermer"
        onClick={() => { setViewPlanCours(!viewPlanCours) }}
        sx={{
          width:"40px", height:"40px", flexShrink:0, cursor:"pointer",
          display:"flex", alignItems:"center", justifyContent:"center",
        }}
      >
        <img src={closeIcon} alt="" style={{ width:"15px", height:"15px", display:"block" }} />
      </Box>
    </Box>
  )
}
const PlanCours = ({ actFormation, actPlan, lastDoneIndex, setViewPlanCours, viewPlanCours }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { forceNewIndexes } = useContext(UserContext)

  const [actFormat, setActFormat] = useState(null)

  const [tab, setTab] = useState("followed")
  const [completed, setCompleted] = useState([])
  const [followed, setFollowed] = useState([])

  useEffect(() => {
    if (actFormation && lastDoneIndex) {
      let newActFormat = actFormation?.chapitre[lastDoneIndex?.chapitre].partie[lastDoneIndex?.partie].sequence[lastDoneIndex?.sequence]
      if (newActFormat) {
        setActFormat(newActFormat)

        /* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 4.1 : LA PARTIE EN
           COURS VA DANS « À SUIVRE », TOUJOURS.
           `lastDoneIndex` est l'ecran de REPRISE (`indexDeReprise` : le premier
           ecran non fait). Le tri se faisait par SEQUENCE : la partie en cours
           partait dans « Complété » si l'apprenant etait au milieu (son premier
           ecran est avant la reprise), et disparaissait des deux onglets s'il
           etait sur son premier ecran. Quand c'etait la derniere partie du
           chapitre, le chapitre en cours sortait de « À suivre », le chapitre
           SUIVANT y prenait l'etiquette « En cours » sans etre commence, et
           l'en-tete, qui comptait les chapitres non faits, en annoncait un de
           plus (« 3 chapitres restants » pour 2 affiches, module « ICEBREAKER
           DEMO valentin »). Et le « Reprendre » de la premiere ligne menait a la
           partie SUIVANTE, en sautant la fin de la partie en cours.
           Desormais le tri se fait par PARTIE : avant la partie de reprise,
           « Complété » ; la partie de reprise et les suivantes, « À suivre ». La
           ligne de la partie en cours reprend a l'ecran de reprise. */
        const avant = (c, p) => c < lastDoneIndex.chapitre || (c === lastDoneIndex.chapitre && p < lastDoneIndex.partie)
        const enCours = (c, p) => c === lastDoneIndex.chapitre && p === lastDoneIndex.partie
        let newCompleted = []
        let newFollowed = []
        actFormation.chapitre.forEach((chapitre, indexChap) => {
          (chapitre?.partie || []).forEach((partie, indexPart) => {
            // L75 : le sommaire n'affiche que le DEBUT de chaque partie
            // (premiere slide), au lieu d'empiler toutes les sequences.
            const premiere = partie?.sequence?.[0]
            if (!premiere) return
            const item = {
              format : JSON.parse(JSON.stringify(premiere)),
              indexes : enCours(indexChap, indexPart) ? { ...lastDoneIndex } : { chapitre: indexChap, partie: indexPart, sequence: 0 },
            }
            if (avant(indexChap, indexPart)) newCompleted.push(item)
            else newFollowed.push(item)
          })
        })

        //console.log(newCompleted)
        //console.log(newFollowed)

        setCompleted(newCompleted)
        setFollowed(newFollowed)
        if (newFollowed.length === 0 && newCompleted.length > 0) {
          setTab("completed")
        } else {
          setTab("followed")
        }
      }
    } else {
      setActFormat(null)
      setCompleted([])
      setFollowed([])
    }
  }, [actFormation, lastDoneIndex])



  /* ⛔ PLAN DE FORMATION — RECONSTRUIT D'APRES LE NODE 4:1850, PAS ADAPTE.
     L'ecran precedent etait l'ANCIEN design : grandes vignettes video, titre
     « Continuer », et l'ancien bandeau bas que le redesign a supprime. Aucune
     de ses zones ne se retrouvait sur la planche. On repart donc de la planche.

     Composition relevee : page teintee, colonne centree de 1320 px a 120 px du
     haut, `gap 60`. Une rangee d'en-tete (vignette 140 + « Module » 20px +
     titre 42px + barre 150x5 + pourcentage, et a droite le reste a faire + un
     bouton noir 150x50). Puis les onglets, soulignes sur 64 px. Puis la liste,
     groupee par chapitre : un bandeau `#f2f0ef` bordé `#e7e7e7` portant le
     titre 22px et l'etat a droite, et sous lui des lignes BLANCHES bordees,
     `px-20 py-15`, avec une icone de 55 px, le titre 18px et son type en 14px.
     Le chapitre a venir est le meme bloc a `opacity 0.4`.

     ⚠️ DEUX COLONNES DE LA PLANCHE N'ONT PAS DE DONNEE DERRIERE, et on ne les
     invente pas : l'auteur par ligne (le modele n'en porte pas ; l'ancien ecran
     affichait un « Nawal Abboub » ecrit en dur) et la duree par ligne (la duree
     n'existe qu'au niveau du CHAPITRE, ce que le point 1.2 de la fiche V2 avait
     deja tranche). Elles sont donc absentes, et signalees au rapport. */
  const pct = Math.round(Number(actFormation?.progress) || 0)
  const nbChapitres = actFormation?.chapitre?.length || 0
  /* Point 4.1 (06/10/2026) : les chapitres restants SONT ceux de « À suivre »,
     chapitre en cours compris, dans le meme ordre. Ils etaient comptes a part
     (chapitres dont un ecran n'est pas fait), et les deux listes divergeaient
     des que la partie en cours etait mal classee (voir l'effet plus haut). */
  const restants = followed
    .map((item) => item?.indexes?.chapitre)
    .filter((iChap, i, tous) => tous.indexOf(iChap) === i)
    .map((iChap) => actFormation?.chapitre?.[iChap])
    .filter(Boolean)
  const minutesRestantes = restants.reduce((n, ch) => n + (Number(ch?.time) > 0 ? Number(ch.time) : 0), 0)
  const dureeLisible = (min) => min <= 0 ? "" : (min >= 60 ? `${Math.floor(min / 60)}h${String(min % 60).padStart(2, "0")}` : `${min} min`)

  const reprendre = () => {
    if (lastDoneIndex) { forceNewIndexes(lastDoneIndex); setViewPlanCours(false) }
  }

  /* Texte rogne aux capitales et a la ligne de base, comme la planche (4:1901
     pour les onglets, 4:1881 a 4:1887 pour l'en-tete), point 2.3. Chrome et
     Safari l'appliquent ; Firefox garde l'interligne entier, ecart accepte
     (voir ROGNE_HAUT, FormatsHelpers). */
  const ETIQUETTE_ONGLET = { textBox:"trim-both cap alphabetic" }

  const BOUTON_NOIR = {
    backgroundColor:"#0A0A0B", color:"white", border:"none", cursor:"pointer",
    fontFamily:"inherit", fontSize:"16px", display:"flex", alignItems:"center",
    justifyContent:"space-between", gap:"8px", padding:"0px 15px", height:"50px",
    flexShrink:0,
  }

  return (
    <Box sx={{
      position:"absolute", top:0, left:0, width:"100%", height:"100vh",
      backgroundColor:"background.grey", zIndex:99,
      display:"flex", flexDirection:"column",
    }}>
      <TopBar setViewPlanCours={setViewPlanCours} viewPlanCours={viewPlanCours} nomModule={actFormation?.name} />
      <Box sx={{ flex:1, display:"flex", justifyContent:"center", overflowX:"hidden", overflowY:"auto" }}>
        <Box sx={{
          width:"100%", maxWidth:"1320px", boxSizing:"border-box",
          /* Le 120 de la planche est mesure depuis le HAUT DE LA PLAQUE, barre de
             75 px comprise ; en CSS ce retrait s'applique SOUS la barre, d'ou
             45 et non 120. */
          padding:["30px 25px 40px", "45px 40px 48px", "45px 60px 60px", "45px 0px 60px"],
          display:"flex", flexDirection:"column",
          gap:["40px", "60px", "60px", "60px"],
        }}>

          {/* RANGEE D'EN-TETE (node 4:1852) */}
          <Box sx={{
            display:"flex", width:"100%",
            flexDirection:["column", "row", "row", "row"],
            alignItems:["flex-start", "flex-start", "flex-end", "flex-end"],
            justifyContent:"space-between", gap:["20px", "24px", "30px", "30px"],
          }}>
            {/* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.1 : LA VIGNETTE DE
                LA PLANCHE. C'etait l'ecran courant rendu en miniature
                (`ScaleThumbForm`, un 1500 x 1000 reduit) : dans une case carree il
                restait petit et couche. La planche pose la MOSAIQUE carree
                (4:1854 Desktop, 13:752 Tablet : 140 x 140 ; 13:857 Mobile : 80 x 80),
                la meme que la fin de module (4:785, `vignetteModule.png`, exportee
                par Hicham le 01/10) : marque decorative, la meme pour tous les
                modules. A cote du bloc Module / titre / progression et centree sur
                lui, a 30 px (4:1853, 13:751) ; AU-DESSUS de lui en Mobile, a 20 px
                (13:856 : colonne). */}
            <Box sx={{ display:"flex", flexDirection:["column", "row", "row", "row"], gap:["20px", "30px", "30px", "30px"], alignItems:["flex-start", "center", "center", "center"], minWidth:0, maxWidth:"100%", width:["100%", "auto", "auto", "auto"] }}>
              <Box component="img" src={vignetteModule} alt="" sx={{ width:["80px", "140px", "140px", "140px"], height:["80px", "140px", "140px", "140px"], flexShrink:0, display:"block" }} />
              {/* Mobile : le bloc prend toute la largeur, la barre de progression
                  aussi (13:888 : 309 px + 10 + « 68% ») */}
              <Box sx={{ display:"flex", flexDirection:"column", gap:["15px", "25px", "25px", "25px"], minWidth:0, alignSelf:["stretch", "auto", "auto", "auto"] }}>
                {/* Point 2.3 : textes rognes comme la planche (4:1881, 4:1882, 4:1887 :
                    13, 28 et 11 px de haut, a 25 px l'un de l'autre), sinon le bloc
                    grandissait de leurs interlignes. */}
                <Box sx={{ fontSize:["16px", "18px", "20px", "20px"], lineHeight:1.2, color:"rgba(0,0,0,0.7)", ...ETIQUETTE_ONGLET }}>
                  {languageValues?.formation?.planCours?.module?.[actLanguage] || "Module"}
                </Box>
                <Box sx={{ fontSize:["32px", "42px", "42px", "42px"], lineHeight:1.15, color:"text.black", overflowWrap:"anywhere", ...ETIQUETTE_ONGLET }}>
                  {actFormation?.name}
                </Box>
                <Box sx={{ display:"flex", gap:"10px", alignItems:"center" }}>
                  <Box sx={{ width:["100%", "150px", "150px", "150px"], flex:["1", "unset", "unset", "unset"], height:"5px", backgroundColor:"#E7E7E7", flexShrink:0 }}>
                    <Box sx={{ width: pct + "%", height:"100%", backgroundColor:"#0A0A0B" }} />
                  </Box>
                  <Box sx={{ fontSize:"16px", letterSpacing:"-0.32px", color:"#0A0A0B", ...ETIQUETTE_ONGLET }}>{pct}%</Box>
                </Box>
              </Box>
            </Box>
            {/* Tablet : « N chapitres restants » AU-DESSUS du bouton, cale a droite
                (13:786, colonne, ecart 20) ; cote a cote, ils prenaient la largeur
                du titre, qui passait sur deux lignes et grandissait l'en-tete
                (point 2.3). */}
            <Box sx={{ display:"flex", flexDirection:["row", "column", "row", "row"], gap:"20px", alignItems:["center", "flex-end", "center", "center"], flexShrink:0 }}>
              {restants.length > 0 &&
                <Box sx={{ fontSize:"14px", color:"rgba(10,10,11,0.7)", textAlign:"right", display:["none", "block", "block", "block"] }}>
                  {restants.length} {languageValues?.formation?.planCours?.chaptersLeft?.[actLanguage] || "chapitres restants"}
                  {minutesRestantes > 0 ? ` (${dureeLisible(minutesRestantes)})` : ""}
                </Box>
              }
              {actFormation?.isOpen &&
                <Box component="button" onClick={reprendre} sx={{ ...BOUTON_NOIR, width:"150px" }}>
                  <Box component="span" sx={{ flex:1, textAlign:"center" }}>
                    {languageValues?.formation?.planCours?.resume?.[actLanguage] || "Reprendre"}
                  </Box>
                  <Box component="span" sx={{ fontSize:"14px" }}>›</Box>
                </Box>
              }
            </Box>
          </Box>

          {/* ONGLETS ET LISTE (node 4:1898) */}
          {/* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.3 : LA STRUCTURE
              VERTICALE DE LA PLANCHE. En-tete, 60 px, onglets, 25 px, premier
              chapitre (4:1851, 4:1898 ; Mobile 40 / 20 : 13:854, 13:892). Les
              libelles des onglets gardaient leur interligne entier (26 px) la ou
              la planche les rogne aux capitales (4:1901 : 12 px de haut), d'ou
              environ 15 px de vide en trop sous l'en-tete ; et en Mobile, 15 px
              au lieu de 20 sous les onglets, 15 au lieu de 12 sous le libelle
              (13:893). */}
          {/* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.2 (tranche par elle) :
              LES DEUX ONGLETS SONT TOUJOURS LA. Chacun n'etait rendu que s'il
              avait au moins un element : au debut du module il manquait
              « Complété », a la fin « À suivre ». Vide, un onglet reste visible et
              cliquable, et rien ne s'affiche dessous, sans message. L'onglet actif
              par defaut ne change pas (« À suivre » s'il a quelque chose, sinon
              « Complété », voir l'effet plus haut).
              ⚠️ ET LE LIBELLE « À SUIVRE » ETAIT VIDE : le code lisait
              `planCours.followed`, cle absente du dictionnaire, qui porte
              `planCours.comingUp` (« À suivre » / « Coming up »). L'onglet
              n'affichait donc que son trait, de largeur nulle.
              Style de la planche (4:1899, 13:893) : 18 px (16 en Mobile), noir
              pour l'actif et noir a 60 % pour l'autre, 25 px entre eux (15 en
              Mobile), trait de 1 px sous l'actif seul, a sa largeur, sur une
              seule ligne, cale a gauche comme la vignette (x=96). */}
          <Box sx={{ display:"flex", flexDirection:"column", gap:["20px", "25px", "25px", "25px"], width:"100%" }}>
              <Box sx={{ display:"flex", flexDirection:"column", gap:"15px", alignItems:"flex-start" }}>
                  {/* ⛔ LE TRAIT SUIT L'ONGLET ACTIF (21/09/2026, lot C). Il etait rendu
                      APRES la rangee, en 64 px ancres a gauche : il restait sous le PREMIER
                      onglet quel que soit l'onglet choisi. Avec un seul onglet visible
                      l'erreur ne se voyait pas — c'est ainsi qu'elle a passe les captures. */}
                <Box role="tablist" sx={{ display:"flex", gap:["15px", "25px", "25px", "25px"], alignItems:"flex-start", fontSize:["16px", "18px", "18px", "18px"], lineHeight:"26px", whiteSpace:"nowrap" }}>
                  {[["followed", "comingUp"], ["completed", "completed"]].map(([onglet, cle]) => (
                    <Box key={onglet} role="tab" aria-selected={tab === onglet} onClick={() => setTab(onglet)} sx={{ cursor:"pointer", display:"flex", flexDirection:"column", gap:["12px", "15px", "15px", "15px"], alignItems:"flex-start", flexShrink:0, color: tab === onglet ? "text.black" : "rgba(0,0,0,0.6)" }}>
                      <Box sx={ETIQUETTE_ONGLET}>{languageValues?.formation?.planCours?.[cle]?.[actLanguage]}</Box>
                      <Box sx={{ width:"100%", height:"1px", backgroundColor: tab === onglet ? "#0A0A0B" : "transparent" }} />
                    </Box>
                  ))}
                </Box>
              </Box>

              <Box sx={{ display:"flex", flexDirection:"column", gap:["15px", "25px", "25px", "25px"], width:"100%" }}>
                {["followed", "completed"].map((onglet) => {
                  if (tab !== onglet) return null
                  const liste = onglet === "followed" ? [...followed] : [...completed].reverse()
                  /* Regroupement par chapitre : les listes sont ordonnees, donc
                     les parties d'un meme chapitre restent contigues. */
                  const groupes = []
                  liste.forEach((item) => {
                    const iChap = item?.indexes?.chapitre
                    const dernier = groupes[groupes.length - 1]
                    if (dernier && dernier.iChap === iChap) dernier.items.push(item)
                    else groupes.push({ iChap, items: [item] })
                  })
                  return groupes.map((groupe, ig) => (
                    <GroupeChapitre
                      key={onglet + "-" + ig}
                      chapitre={actFormation?.chapitre?.[groupe.iChap]}
                      items={groupe.items}
                      onglet={onglet}
                      encours={onglet === "followed" && ig === 0}
                      actFormation={actFormation}
                      actPlan={actPlan}
                      setViewPlanCours={setViewPlanCours}
                      boutonNoir={BOUTON_NOIR}
                    />
                  ))
                })}
              </Box>
          </Box>
        </Box>
      </Box>
      {/* Pas de bandeau bas : la planche n'en montre aucun. */}
    </Box>
  )
}


/* ⛔ UN GROUPE = UN CHAPITRE, RECONSTRUIT D'APRES LE NODE 4:1905.
   Un bandeau `#f2f0ef` borde `#e7e7e7` portant le titre du chapitre a gauche et
   son etat a droite, puis les lignes BLANCHES bordees, collees les unes aux
   autres sans espace. Le chapitre a venir est le meme bloc a `opacity 0.4`.
   Le point 1.2 de la fiche V2 reste respecte : la duree ne vit QUE dans ce
   bandeau, jamais sur les lignes. */
const GroupeChapitre = ({ chapitre, items, onglet, encours, actFormation, actPlan, setViewPlanCours, boutonNoir }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const titre = chapitre?.title || ""
  const duree = Number(chapitre?.time) > 0 ? Number(chapitre.time) : null
  const total = (chapitre?.partie || []).length
  const faites = (chapitre?.partie || []).filter((pa) => (pa?.sequence || []).every((sq) => sq?.isDone)).length
  const aVenir = onglet === "followed" && !encours

  /* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.4 : la duree du chapitre
     apres « En cours » aussi, meme regle que « À venir » (rien si `time` est
     vide ou a 0). Elle reste dans ce bandeau seul, jamais sur les lignes.
     « Complété » est laisse tel quel. */
  const suffixeDuree = duree ? " · " + duree + " min" : ""
  const etat = onglet === "completed"
    ? (languageValues?.formation?.planCours?.completed?.[actLanguage] || "Complété")
    : encours
      ? `${languageValues?.formation?.planCours?.inProgress?.[actLanguage] || "En cours"} · ${faites + 1} / ${total}${suffixeDuree}`
      : `${languageValues?.formation?.planCours?.upcoming?.[actLanguage] || "À venir"}${suffixeDuree}`

  return (
    <Box sx={{ display:"flex", flexDirection:"column", width:"100%", opacity: aVenir ? 0.4 : 1 }}>
      {titre &&
        <Box sx={{
          backgroundColor:"#F2F0EF", border:"1px solid #E7E7E7", boxSizing:"border-box",
          display:"flex", alignItems:"center", justifyContent:"space-between", gap:"16px",
          padding:["14px 16px", "20px", "20px", "20px"], width:"100%",
        }}>
          <Box sx={{ fontSize:["17px", "19px", "22px", "22px"], lineHeight:1.15, color:"text.black", overflowWrap:"anywhere" }}>{titre}</Box>
          <Box sx={{ fontSize:"14px", lineHeight:"26px", color:"rgba(10,10,11,0.7)", whiteSpace:"nowrap", flexShrink:0 }}>{etat}</Box>
        </Box>
      }
      <Box sx={{ display:"flex", flexDirection:"column", width:"100%" }}>
        {items.map((item, k) => (
          <LigneFormat
            key={k}
            item={item}
            onglet={onglet}
            premiereDuChapitreEnCours={encours && k === 0}
            actFormation={actFormation}
            actPlan={actPlan}
            setViewPlanCours={setViewPlanCours}
            boutonNoir={boutonNoir}
          />
        ))}
      </Box>
    </Box>
  )
}

/* Une ligne = une PARTIE (granularite deja tranchee au point L75).
   Node 4:1910 : fond blanc, bordure `#e7e7e7`, `px-20 py-15`, icone de 55 px
   encadrant un carre blanc de 43 px, puis le titre en 18px (le type en 14px
   de la planche est retire, point 2.5 de la review du 5 oct).
   Le bouton noir « Reprendre » n'apparait que sur la ligne courante. */
const LigneFormat = ({ item, onglet, premiereDuChapitreEnCours, actFormation, actPlan, setViewPlanCours, boutonNoir }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { forceNewIndexes } = useContext(UserContext)
  const cliquable = onglet === "completed" || premiereDuChapitreEnCours
  const ouvrir = () => { forceNewIndexes(item?.indexes); setViewPlanCours(false) }

  const partie = actFormation?.chapitre?.[item?.indexes?.chapitre]?.partie?.[item?.indexes?.partie]
  const titre = partie?.title || item?.format?.exerciceTitle || ""
  /* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.5 : LE TITRE SEUL. La
     seconde ligne (type du format, et duree de la video quand elle etait
     saisie) est retiree, ECART VOULU PAR NAWAL a la planche 4:1910, qui montre
     « Video · 8 minutes ». La duree vit dans le bandeau du chapitre seulement
     (point 2.4). Le titre se centre sur l'icone (`alignItems: center`). */

  return (
    <Box
      onClick={cliquable ? ouvrir : null}
      sx={{
        backgroundColor:"white", border:"1px solid #E7E7E7", boxSizing:"border-box",
        display:"flex", alignItems:"center", gap:["16px", "40px", "40px", "40px"],
        padding:["12px 16px", "14px 20px", "15px 20px", "15px 20px"], width:"100%",
        cursor: cliquable ? "pointer" : "default",
        "&:hover": cliquable ? { borderColor:"#0A0A0B" } : {},
      }}
    >
      <Box sx={{ display:"flex", flex:1, gap:["20px", "20px", "20px", "20px"], alignItems:"center", minWidth:0 }}>
        {/* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 2.6 : L'ICONE DE LA
            PLANCHE. Le composant « icon » (4:1912 ; Mobile 13:906) : cadre de 55
            (45 en Mobile) #FAF8F6 a filet de 0,5 #E6E6E7, carre blanc de 43 (35)
            CENTRE dedans, a 6 px (5) du bord, ombre 0 2 1,5 0,5 rgba(149,160,178,
            0.16), et la « cible » de 20 x 20 aux deux tailles (4:1914) a la place
            du cube. Le carre blanc remplissait le cadre (46 au lieu de 43). La
            planche pose la MEME icone sur toutes les lignes, quels que soient le
            type et l'etat (« À suivre » 4:1850 comme « Complété » 4:2022). */}
        <Box sx={{
          width:["45px", "55px", "55px", "55px"], height:["45px", "55px", "55px", "55px"], flexShrink:0,
          backgroundColor:"background.grey", border:"0.5px solid #E6E6E7",
          display:"flex", alignItems:"center", justifyContent:"center", boxSizing:"border-box",
        }}>
          <Box sx={{
            width:["35px", "43px", "43px", "43px"], height:["35px", "43px", "43px", "43px"], flexShrink:0, backgroundColor:"white",
            boxShadow:"0px 2px 1.5px 0.5px rgba(149,160,178,0.16)",
            display:"flex", alignItems:"center", justifyContent:"center",
          }}>
            <img src={cibleIcon} alt="" style={{ width:"20px", height:"20px", display:"block" }} />
          </Box>
        </Box>
        <Box sx={{ minWidth:0 }}>
          <Box sx={{ fontSize:["16px", "17px", "18px", "18px"], lineHeight:1.15, color:"text.black", overflowWrap:"anywhere" }}>{titre}</Box>
        </Box>
      </Box>
      {/* ⚠️ MARQUEUR DES LIGNES TERMINEES, absent du code (audit du 22/09).
          La planche pose a droite de chaque ligne de l'onglet « terminees » un
          bloc de 90 x 20 : pastille de validation de 20 px + libelle. Le code
          ne rendait RIEN : une ligne faite et une ligne a faire se
          ressemblaient, sauf sur la ligne courante qui porte le bouton.
          Masque au palier xs, ou la planche Mobile ne le montre pas. */}
      {onglet === "completed" && !premiereDuChapitreEnCours &&
        <Box sx={{
          display:["none", "flex", "flex", "flex"],
          alignItems:"center",
          gap:"8px",
          flexShrink:0,
        }}>
          <Box sx={{
            width:"20px", height:"20px", borderRadius:"50%", flexShrink:0,
            backgroundColor:"#53D769",
            display:"flex", alignItems:"center", justifyContent:"center",
          }}>
            <Box component="span" sx={{ color:"#FFFFFF", fontSize:"12px", lineHeight:1 }}>{"\u2713"}</Box>
          </Box>
          <Box sx={{ fontSize:"14px", lineHeight:"20px", color:"rgba(10,10,11,0.7)", whiteSpace:"nowrap" }}>
            {languageValues?.formation?.planCours?.completed?.[actLanguage]}
          </Box>
        </Box>
      }
      {premiereDuChapitreEnCours &&
        <Box component="button" onClick={(e) => { e.stopPropagation(); ouvrir() }} sx={{ ...boutonNoir, height:"42px", fontSize:"14px" }}>
          <Box component="span">{languageValues?.formation?.planCours?.resume?.[actLanguage] || "Reprendre"}</Box>
          <Box component="span">›</Box>
        </Box>
      }
    </Box>
  )
}

export default PlanCours
